import { maxBreakpoints, minBreakpoints, theme } from '@noths/polaris-client-ribbons-base';
import { mediaQuery, pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { spacing } = theme;

export const heading = css`
  ${theme.responsiveText.HEADING.MD}
  color: var(--neutral-black-base);
  margin: 0 0 ${spacing.md}px 0;
`;

export const subHeading = css`
  ${theme.responsiveText.HEADING.SM}
  margin: 0 0 ${spacing.sm}px 0;
`;

export const form = css`
  padding: ${pxToRem(32)} ${pxToRem(16)};
  text-align: center;
  margin: 0 auto;

  ${mediaQuery(
    { max: maxBreakpoints.S },
    css`
      max-width: ${pxToRem(360)};
    `,
  )};

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      max-width: ${pxToRem(640)};
    `,
  )};
`;

export const formButtons = css`
  margin-bottom: ${spacing.md}px;

  > div {
    margin-bottom: ${spacing.md}px;
  }

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      column-gap: ${pxToRem(spacing.lg)};

      > div {
        flex-grow: 1;
        margin-bottom: 0;
      }
    `,
  )};

  ${mediaQuery(
    { min: minBreakpoints.XS, max: maxBreakpoints.XS },
    css`
      max-width: ${pxToRem(minBreakpoints.XS)};
    `,
  )};
`;

export const smallPrint = css`
  ${theme.responsiveText.BODY.XS}
  margin: 0 0 ${spacing.md}px 0;
  color: var(--neutral-black-base);
`;
